<template>
	<header-block title="" border="0" bgcolor="transparent"></header-block>
	
	<div class="simplePage">
		<img class="heroImg" src="../assets/verified.png" />
		<h1>Success!</h1>
		<p>You have successfully added your {{type}}.</p>
		<div class="anchor-bottom">
			<MGButton text="Done" @click="$router.push('/money')" :arrow="false"/>
		</div>
		
	</div>

</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';

export default {
	mixins: [Services],
	components: {MGButton, HeaderBlock},
	data() {
		return {
			employer: null,
			interval: null
		}
	},
	computed: {
		type() {
			return this.$route.query.type;
		},
		section() {
			if (this.$route.query.type === 'pension' || this.$route.query.type === 'mortgage') {
				return 'lt';
			} else if (this.$route.query.type === 'policy') {
				return 'ins';
			} else if (this.$route.query.type === 'account') {
				return 'd2d';
			}
			// Default fallback
			return 'd2d';
		}
	},
	methods: {
		onLoad: async function() {
			
		}
	},
	mounted: function () {
		this.onLoad();
	}
}
</script>

<style scoped>



</style>
